<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName? this.params.colDef.headerName : null
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "albumRegistration",
    data() {
      return {
        fileUrl: `${process.env.VUE_APP_API_URL}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
          'Access-Control-Allow-Origin': '*',
        },
        ko : ko,
        selectLicensor : [],
        optionData: optionData,
        memberOption : optionData.memberKeyword,
        page: {
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수cline_text : this.cline_text
        },
        selectGenre : [],
        genreOption : [],

        albumGenre:[] ,
        albumStatusOption : optionData.albumStatus,
        albumStatus : 'registration_complete',

        sourceOption : optionData.albumSource,
        source : 'direct',
        releaseOption: optionData.releaseType,
        release_type : null,
        youtubeCIDOption:optionData.youtubeCID,
        youtube_cid : 'none' ,
        youtube_sr : true,
        youtube_at : true,
        
        copyrightOption : optionData.copyrightType,
        copyright : 'new',
        
        tractOption : optionData.trackType,
        tractType :  null ,
        trackTypeInput : null ,

        transfer_date : null,
        transfer_name : null,
        
        
        country : null ,
        original_release_date : null,
        release_date : null,
        release_time : '12:00:00',
        desired_release_date : null,
        
        
        tags : [[]],
        tags_v2 : [],
        contractDuration : null,
        contract : {
          service_fee_other :null,
          service_fee_kr :null,
          territory : null,
          territory_exception : '',
          territory_exception_v2 : [],
          start_date : null,
          end_date : null,
        },
        feeEditMode : false,
        //앨범 명
        name : null ,
        name_language : 'ko',
        name_english: null,
        name_multilang : {},
        name_export:{},
        coverimage: null,
        coverimage_id: null,
        
        //앨범 버전  
        release_version : null ,

        //기획사명
        label: null,
        label_english: null,
        label_language: 'ko',
        labelimage: null,
        labelimage_id: null,
        

        credit :null,
        nationality : null,
        countryOption : optionData.country,
        languageOption : optionData.language,

        audioLanguageOption : [
          {"code":"zxx","name":"언어없음-ZXX","en_name":"No language-ZXX","original":"한국어"},
          ...optionData.language
        ],
        
        description_language: 'ko',
        description : null ,
        description_english : null,
        //유통사 

        distributor : 'Sound Republica, Inc.',


        cline_text: null,
        cline_year: null,
        pline_text: "under license to Sound Republica, Inc..",
        pline_year: null,

        album_ref :null,
        barcode:null,

        has_mv : false,
        gridOptions :{ // 테이블 옵션
            onRowClicked: (event)=>{
                
            },
        },
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        columnDefs: [
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
          {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
              let text = ""
              text += "국내 : " + data.value + '%   '
              text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
              return text
          }},
        ],

        // 라이센서 추가
        gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        gridOptionsUser :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
            componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
          }
        },
        columnDefsUser : [
          {headerName: '선택', field: 'email', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.selectLicensorData(data)
                this.context.componentParent.closeModal('licensor')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
          {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
              let text = ""
              text += "국내 : " + data.value + '%   '
              text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
              return text
          }},
        ],
        keywordType : {label:'권리자명', value:'_name'},
        licensorKeyword : '',
        userList: {
          listData: [],                 
          pageSize: 10,                 
          currentPage: 1,
          totalPage: 0,                
        },


        artistData :{
          gridOptions:{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
            context: {
                componentParent: this
            },
            onGridReady: function (event) {
            },
            frameworkComponents : {
              btnSelect : BtnSelect
            }
          },
          columnDefs : [
            {headerName: '선택', field: 'id', filter: false,width: 100,
              cellRendererParams: {
                clicked: function(data) {
                  let list = this.context.componentParent.selectArtist
                  let various = this.context.componentParent.variousArtist
                  let found = list.find(element => element.id == data.id);
                  let foundVarious = list.find(element => element.id == various.id);
                  
                  if(foundVarious!= undefined){
                    this.context.componentParent.selectArtist= [data]
                    this.context.componentParent.variousArtistStatus = false
                  }else{
                    if(found == undefined) {
                      this.context.componentParent.selectArtist.push(data)
                    }else{
                      this.context.componentParent.alert({msg: '이미 선택된 아티스트입니다.'})
                    }
                  }
                  
                  
                  //this.context.componentParent.closeModal('artist')
                }
              },
              cellRenderer: 'btnSelect'
            },
            {headerName: '아티스트명', field: 'display_name', filter: false,width: 250,
            cellRenderer: (data) => {
                if(data.data.profile['thumbnail']){
                    return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
                }else{
                    return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
                }
            }},
            {headerName: '아티스트명(번역)',  field: 'display_name_english',  filter: false,width: 250},
            {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
            }},
          ],
        },

        artistKeywordOption : [
          {value: 'display_name', label: '아티스트명'},
          {value: 'display_name_english', label: '아티스트명(번역)'}
        ],
        artistKeywordType : {value: 'display_name', label: '아티스트명'},
        artistKeyword : null,
        artistList: {
          listData: [],                 
          pageSize: 5,                 
          currentPage: 1,
          totalPage: 0,                
        },
        selectArtist : [],
        variousArtist : [],
        variousArtistStatus : false,
        // track
        trackData :{
            gridOptions:{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
              context: {
                  componentParent: this
              },
              onGridReady: function (event) {
              },
              frameworkComponents : {
                btnSelect : BtnSelect
              }
            },
            columnDefs : [
              {headerName: '선택', field: 'id', filter: false,width: 100,
                cellRendererParams: {
                  clicked: function(data) {
                    let t = this.context.componentParent
                    let list = t.selectTrackArtist
                    let various = t.variousArtist
                    let found = list.find(element => element.id == data.id);
                    let foundVarious = list.find(element => element.id == various.id);
                    console.log('t.selectTrackArtist', t.selectTrackArtist )
                    console.log('t.selectArtist', t.selectArtist )
                    if(foundVarious!= undefined){
                      this.context.componentParent.selectTrackArtist= [data]
                      this.context.componentParent.variousTrackArtistStatus = false
                    }else{
                      if(found == undefined) {
                        this.context.componentParent.selectTrackArtist.push(data)
                      }else{
                        this.context.componentParent.alert({msg: '이미 선택된 아티스트입니다.'})
                      }
                    }
                    
                    
                    //this.context.componentParent.closeModal('artist')
                  }
                },
                cellRenderer: 'btnSelect'
              },
              {headerName: '아티스트명', field: 'display_name', filter: false,width: 250,
              cellRenderer: (data) => {
                  if(data.data.profile['thumbnail']){
                      return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
                  }else{
                      return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
                  }
              }},
              {headerName: '아티스트명(번역)',  field: 'display_name_english',  filter: false,width: 250},
              {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
              cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
              }},
            ],
        },
        trackList : [[]],
        parentalOtion:[
          {label : 'explicit', value : "explicit"},
          {label : 'not_explicit', value : "not_explicit"},
          {label : 'explicit_content_edited', value : "explicit_content_edited"},
          {label : 'user_defined', value : "user_defined"},
          {label : 'no_advice_available', value : "no_advice_available"},
          {label : 'unknown', value : "unknown"},
        ],
        trackModalMode : null,
        trackTemplate :{
          name : '',
          name_language : 'ko',
          name_english : '',
          genre1_id :null,
          genre2_id : null,
          name_multilang : {},
          name_export:{},
          artists : [],
          files : [],
          contributors : [],
          featuring_artists:'',
          featuring_artists_english:'',
          featuring_artists_language:'ko',
          lyrics : '',
          lyrics_language :'ko' ,
          parental_warning : 'not_explicit', // not_explicit , explicit
          explicit : false,
          titletrack : 0,
          tracknr: 1,
          //track_ref: '',
          type : 'original',// 트랙유형
          uci : '',
          uci_generate :false,
          isrc : '',
          isrc_generate :false,
          iswc: '',
          volume : 1,
          is_takedown :false,
        },
        
        trackDetail :{
          name : '',
          name_language : 'ko',
          name_english : '',
          name_multilang : {},
          name_export:{},
          genre1_id :null,
          genre2_id : null,
          isrc : '',
          artists : [],
          files : [],
          featuring_artists:'',
          featuring_artists_english:'',
          featuring_artists_language:'ko',
          lyrics : '',
          lyrics_language :'' ,
          contributors : [],
          parental_warning : 'not_explicit', // not_explicit , explicit
          titletrack : 0,
          tracknr: 1,
          //track_ref: '',
          explicit : false,
          type : 'original',// 트랙유형
          alt_type : null,
          uci : null,
          iswc: '',
          volume : 1,
          is_takedown :false
        },
        
        contributorsRole :'composer',
        contributorsRoleOption : optionData.contributors,
        contributorsName : null,
        contributorsCompany : null,
        contributorsIpi:null,
        variousTrackArtistStatus : false,
        trackGenre : [],
        selectTrackArtist : [],
        trackTypeOption : optionData.trackType,
        trackTitleOption : [
          {label : '대표곡 NO',value :0},
          {label : 'Y1',value :1},
          {label : 'Y2',value :2},
          {label : 'Y3',value :3},
          {label : 'Y4',value :4},
        ],

        files1 : [],          // 파일 데이터
        files2 : [],
        files3 : [],

        file1: {
          id :null,
          preview : ''
        },// profile
        file2: {
          id :null,
          preview : ''
        },
        file3: {
          id :null,
          preview : ''
        },

        accept:"",
        extensions:'',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        
        uploadAuto: false,
        audioList : [],
      }
    },
    mounted(){
      this.getGenreList()
      this.$nextTick(function(){
        
      })
    },
    computed: {
      
    },
    watch:{
      'trackTemplate'(va){console.log(va)},
      'label'(){
        if(this.label){
          this.pline_text = this.label + ', under license to Sound Republica, Inc.'
        }
        
      },
      'userList.currentPage'(){
        this.getUserList()
      },
      'artistList.currentPage'(){
        this.getArtistList()
      },
     'contractDuration'(num){ 
       if(num != '0' && this.contract.start_date){
         
         this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',num) ))
         console.log(this.contract.end_date)
       }
      },
     'contract.start_date'(){
       if(this.contractDuration != '0' && this.contract.start_date){
         this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',this.contractDuration) ))
       }
      },
      'selectArtist'(){
        if(this.selectArtist.length > 4){
          this.alert({msg:'아티스트 선택은 최대 4명까지 가능합니다.'});
          this.selectArtist.length = 4
        }
      },
      'copyright'(){
        this.transfer_date = null
        this.transfer_name = null
      },
      'contract.territory'(){
        this.territory_exception = null
      }
    },
    methods: {
      
      //Licensor 매칭
      selectLicensorData (data){
        this.trackList = [[]]
        this.selectArtist = []
        this.selectTrackArtist = []
        this.trackGenre = []
        
        
        this.selectLicensor= [data]
        this.contract.service_fee_kr = this.selectLicensor[0].licensor.default_service_fee_kr
        this.contract.service_fee_other = this.selectLicensor[0].licensor.default_service_fee_other
      },
      openLicensor(){
        this.userList.currentPage = 1
        this.keywordType =  {label:'권리자명', value:'_name'},
        this.licensorKeyword = '',
        this.openModal('licensor');
        this.getUserList()
      },
      getUserList(){
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          role : 'licensor',
          page: this.userList.currentPage-1 ,
          limit: this.userList.pageSize
        }
        if(this.keywordType && this.keywordType !='') {
            option[this.keywordType.value] = this.licensorKeyword
        }
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
            this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      //Artist 매칭
      openArtist(){
        if(this.selectLicensor.length == 0) {
          this.alert({msg:'Licensor 매칭을 해주세요.'})
          
          return false;
        }
        this.artistList =  {
          listData: [],                 
          pageSize: 5,                 
          currentPage: 1,
          totalPage: 0,                
        },
        this.artistKeywordType = {value: 'display_name', label: '아티스트명'},
        this.artistKeyword = null,
        this.openModal('artist');
        this.getArtistList()
        this.getArtistVarious()
      },
      removeArtist(index){
        this.selectArtist.splice(index, 1)
        this.variousArtistStatus = false
      },
      getArtistList(){
         const option = {
          licensor_id : this.selectLicensor[0].licensor.id,
          params :{
            sort: 'created_at',
            sortorder: 'desc',
            page: this.artistList.currentPage-1 ,
            limit: this.artistList.pageSize,
            is_various_artists: false,
          }
        }
        if(this.artistKeywordType && this.artistKeywordType !='') {
            option.params[this.artistKeywordType.value] = this.artistKeyword
        }
        this.$store.dispatch('GET_LICENSOR_ARTIST', option).then(result =>{
            
            this.artistList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.artistList.pageSize) > 0? 1: 0
            this.artistList.totalPage = parseInt(result.filtered /this.artistList.pageSize) + remainder
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      // Various artist
      getArtistVarious(){
        const option = {
          licensor_id : this.selectLicensor[0].licensor.id,
          params :{
            page: 0 ,
            is_various_artists: true,
          }
        }
        this.$store.dispatch('GET_LICENSOR_ARTIST', option).then(result =>{
            
            if(result.items.length == 0) {
              this.alert({msg:'Various 아티스트가 존재하지 않습니다. 개발팀에게 문의해주세요.'})
              this.closeModal('artist')
            }
            this.variousArtist  = result.items[0] // 권리자 목록
            console.log(result.items)
            
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      
      albumVarious(e){
        console.log(e);
        if(e.target.checked){
          this.selectArtist = [this.variousArtist]
        }else{
          this.selectArtist = []
        }
      },

      // 트랙 등록
      openTrack(name, index){
        if(this.selectLicensor.length == 0) {
          this.alert({msg:'Licensor 매칭을 해주세요.'})
          
          return false;
        }
        this.files3 = []
        let data = JSON.parse(JSON.stringify(this.trackTemplate));
        console.log(data.contributors)
        this.trackDetail = {...data,volume : index + 1,
          tracknr : this.trackList[index].length + 1}

        //초기 등록시 앨범의 트랙 장르 참조 
        this.selectTrackArtist = [ ...this.selectArtist ]
        this.trackGenre = [...this.selectGenre]
        
        

        if(this.selectTrackArtist.length > 0 && this.selectTrackArtist[0].is_various_artists){
          this.variousTrackArtistStatus = true
        }else{
          this.variousTrackArtistStatus = false
        }
        this.trackModalMode = 'save'
        this.openModal('track')
      },
      editTrack(index,indexTr){
        let data = JSON.parse(JSON.stringify(this.trackList[index][indexTr]));
        this.trackDetail = {
          ...data,
          volume :  index + 1,
          tracknr : indexTr + 1,
        }
        
        
        const arr = Object.freeze([
            "composer",
            "lyricist",
            "arranger",
            "producer",
            "publisher",
            "remixer",
            "conductor",
            "choir",
            "orchestra",
            "translator",
            "narrator",
            "studio_musician",
            "studio_personnel",
        ])
        this.trackDetail.contributors.sort(function(a,b){
            if(arr.indexOf(a.role)  < arr.indexOf(b.role))
            return -1;
            if(arr.indexOf(a.role)  > arr.indexOf(b.role))
            return 0;
        })
        
          
        if(this.selectTrackArtist.length > 0 &&  this.selectTrackArtist[0].is_various_artists){
          this.variousTrackArtistStatus = true
        }else{
          this.variousTrackArtistStatus = false
        }
        this.files3 = [] 
        this.selectTrackArtist = []
        this.trackGenre = []

        if(this.trackDetail['saveFile']){
          this.files3 = [...this.trackDetail['saveFile']]
        }
        if(this.trackDetail['saveArtist'].length > 0 ){
          this.selectTrackArtist = [...this.trackDetail['saveArtist']]
        }
        if(this.trackDetail['saveGenre']){
          this.trackGenre = [...this.trackDetail['saveGenre']]
        }

        this.trackModalMode = 'edit'
        this.$forceUpdate()
        this.openModal('track')
      },

      saveTrack(){
        console.log(this.trackModalMode)
        if(this.valCheck(this.trackDetail.name)){
          this.alert({msg : '트랙명을 입력해주세요.'})
          return false
        }
        this.loadingShow()
        for (const key in this.trackDetail.name_multilang) {
              if(this.valCheck(this.trackDetail.name_multilang[key]) ){
                delete this.trackDetail.name_multilang[key]
              }else{
              }
          }
        if(this.trackModalMode == 'save'){
          console.log('save first')
          // 편집데이터를 불러오기 위한 컬럼 사용 x
          this.trackDetail['saveFile'] = this.files3
          this.trackDetail['saveArtist'] =  [...this.selectTrackArtist]
          this.trackDetail['saveGenre'] = this.trackGenre
          this.trackDetail.files = []
          for(var i in this.files3){
            this.trackDetail.files.push({id:this.files3[i].response[0].id })
          }
          this.trackDetail.artists = []
          for(var a in this.trackDetail['saveArtist']){
              this.trackDetail.artists.push({id : this.trackDetail['saveArtist'][a].id})
          }
          for(var b in this.trackGenre){
            if(this.trackGenre[b]){
              if(b == 0){
                this.trackDetail.genre1_id = this.trackGenre[b].id
              }else{
                this.trackDetail.genre2_id = this.trackGenre[b].id
              }
              
            }
          }
          if(this.trackDetail.type == 'etc'){
          
          }else{
            this.trackDetail.alt_type = null
          }
          if(this.trackDetail.explicit){
            this.trackDetail.parental_warning = "explicit"
          }else{
            this.trackDetail.parental_warning = "not_explicit"
          }
          
          this.trackList[this.trackDetail.volume-1].push(this.trackDetail)
          setTimeout(() => {
            this.loadingHide();
            this.closeModal('track')  
            this.$forceUpdate()
          }, 300);
        }else{
          console.log('edit save')
          // 편집데이터를 불러오기 위한 컬럼 
          this.trackDetail['saveFile'] =  this.files3
          this.trackDetail['saveArtist'] =  this.selectTrackArtist
          this.trackDetail['saveGenre'] = this.trackGenre
          this.trackDetail.files = []
          //this.trackDetail.files = []
          for(var i in this.files3){
            this.trackDetail.files.push({id:this.files3[i].response[0].id })
          }
          this.trackDetail.artists = []
          for(var a in this.selectTrackArtist){
              this.trackDetail.artists.push({id : this.selectTrackArtist[a].id})
          }
          for(var b in this.trackGenre){
            if(this.trackGenre[b]){
              if(b == 0){
                this.trackDetail.genre1_id = this.trackGenre[b].id
              }else{
                this.trackDetail.genre2_id = this.trackGenre[b].id
              }
              
            }
          }
          console.log(this.trackDetail)
        
          this.trackList[this.trackDetail.volume-1][this.trackDetail.tracknr-1] = this.trackDetail
          setTimeout(() => {
            this.loadingHide();
            
            this.closeModal('track')
            this.$forceUpdate()
          }, 300);
        }
        
      },
      trackVarious(e){
        
        if(e.target.checked){
          this.selectTrackArtist = [this.variousArtist]
        }else{
          this.selectTrackArtist = []
        }
      },
      removeVolume(index){
       
        this.trackList.splice(index , 1)
      },
      removeTrack(vol,index){
        this.trackList[vol].splice(index,1)
      },
      openTrackArtist(){
        if(this.selectLicensor.length == 0) {
          this.alert({msg:'Licensor 매칭을 해주세요.'})
          return false;
        }
        this.artist =  {
          listData: [],                 
          pageSize: 0,                 
          currentPage: 1,
          totalPage: 0,                
        },
        this.artistKeywordType = {value: 'display_name', label: '아티스트명'},
        this.artistKeyword = null,
        this.openModal('trackArtist');
        this.getArtistList()
        this.getArtistVarious()
      },
      removeTrackArtist(index){
        this.selectTrackArtist.splice(index, 1)
        this.variousTrackArtistStatus = false
      },
      getGenreList(){
        this.$store.dispatch('GET_GENRE')
        .then(result =>{
            this.genreOption  = result.items // 권리자 목록
        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
      // 앨범 이미지
      inputFileUpload1(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
          console.log(newFile)
          if(newFile.type.indexOf('image') < 0 ){
            this.alert({msg:'이미지만 등록 가능합니다.'})
            return false
          }
          let file = newFile.file
          let reader = new FileReader
          reader.onload = e => {
            let img = new Image()
            img.src = e.target.result
            img.onload = () =>{
              let imgWidth = img.width
              let imgHeight = img.height
              
              if(imgHeight !=  imgWidth ){
                this.alert({msg:'1:1 비율만 등록 가능합니다.'})
                this.files1 = []
                return false
              }
              this.$refs.upload1.active = true
              this.file1.preview = e.target.result
              
            }
           
          }
          
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {
          // update
          console.log(newFile)
          if(Array.isArray(newFile.response)){
            this.file1 ={
              ...this.file1,
              ...newFile.response[0]
            }
            console.log(this.file1)
          }
          
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      //기획사 이미지
      inputFileUpload2(newFile, oldFile) {
       if (newFile && !oldFile) {
          // add
          console.log('add', newFile)
          if(newFile.type.indexOf('image') < 0 ){
            this.alert({msg:'이미지만 등록 가능합니다.'})
            return false
          }
          this.$refs.upload2.active = true
          let file = newFile.file
          let reader = new FileReader
          reader.onload = e => {
            this.file2.preview = e.target.result
            console.log(e)
          }
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {
          // update
          console.log(newFile)
          if(Array.isArray(newFile.response)){
            this.file2 = {
              ...this.file2,
              ...newFile.response[0]
            }
            console.log(this.file1)
          }
          
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      //트랙 파일
      inputFileUpload3(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
          
          console.log('add', newFile)
          
          this.$refs.upload3.active = true
          
        }
        if (newFile.active && oldFile.active) {
          // update
          if(newFile.type.indexOf('audio') < 0 ){
            this.alert({msg:'오디오(mp3,wav,flac) 파일만 가능합니다.'});
            this.$refs.upload3.remove(newFile)
            return false
          }
          if(newFile.progress == '100.00' ){
           this.loadingHide()
          }
          if(newFile.progress == '0.00' ){
            this.loadingShow();
          }
        }
       
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      
      
      addVolume(){
        this.trackList.push([])
      },
      removeFile(index){
        this.files3.splice(index,1);
      },
      addContributor(){
        if(this.valCheck(this.contributorsRole)){
          this.noti({msg:'참여자 구분을 선택해주세요.'})
          return false
        }
        if(this.valCheck(this.contributorsName)){
          this.alert({msg:'참여자 이름과 업체명 모두 입력해주세요.'})
          return false
        }
        this.trackDetail.contributors.push({
          name : this.contributorsName,
          role : this.contributorsRole,
          copyright_association : this.contributorsCompany,
          ipi : this.contributorsIpi
        })
        const arr = Object.freeze([
            "composer",
            "lyricist",
            "arranger",
            "producer",
            "publisher",
            "remixer",
            "conductor",
            "choir",
            "orchestra",
            "translator",
            "narrator",
            "studio_musician",
            "studio_personnel",
        ])
        this.trackDetail.contributors.sort(function(a,b){
            if(arr.indexOf(a.role)  < arr.indexOf(b.role))
            return -1;
            if(arr.indexOf(a.role)  > arr.indexOf(b.role))
            return 0;
        })
        this.contributorsName = this.contributorsCompany = null
        this.contributorsIpi = null
      },
      removeContributor(index){
        this.trackDetail.contributors.splice(index,1)
      },
      all_save(){
        this.closeModal('confirm')
        if(this.selectLicensor.length < 1) {
          this.alert({msg:'Licensor 매칭을 해주세요.'});
          return false
        }
        if(this.valCheck(this.name)){
          this.alert({msg:'앨범명을 입력해주세요.'});
          return false
        }
        // if(this.valCheck(this.release_type)){
        //   this.alert({msg:'앨범유형을 선택해주세요.'});
        //   return false
        // }
        if(this.valCheck(this.contract.territory)){
          this.alert({msg:'발매 뮤직스토어를 선택해주세요.'});
          return false
        }
        if(this.valCheck(this.contract.start_date)){
          this.alert({msg:'계약 시작일을 선택해주세요.'});
          return false
        } 
        
        for (const key in this.name_multilang) {
            if(this.valCheck(this.name_multilang[key]) ){
              delete this.name_multilang[key]
            }else{
            }
        }
        let payload = {
          licensor_id : this.selectLicensor[0].licensor.id,
          //release_type: this.release_type,
          source: this.source,
          state: this.albumStatus,
          copyright_type: this.copyright,
          distributor: "Sound Republica, Inc.",
          explicit: this.explicit,          
          name: this.name,
          name_language : this.name_language,
          name_english : this.name_english,
          name_multilang : this.name_multilang,
          release_version : this.release_version,
          
          cline_text : this.cline_text,
          pline_text: this.pline_text,

          barcode : this.barcode,
          has_mv : this.has_mv,
          description: this.description,
          description_language: this.description_language,
          description_english: this.description_english,
          credit : this.credit,
          
          youtube_cid: this.youtube_cid,
          youtube_sr : this.youtube_sr,
          youtube_at : this.youtube_at,
          genre1_id : this.selectGenre[0] ? this.selectGenre[0].id :null,
          genre2_id : this.selectGenre[1] ? this.selectGenre[1].id : null,
          
          contract : this.contract,
          label : this.label,
          label_english : this.label_english,
          label_language : this.label_language,

          country : this.country,
          desired_release_date : this.desired_release_date,
          release_time : this.release_time,
          release_date : this.release_date,
          tags : this.tags,
          tags_v2 : this.tags_v2
        }
        if(!this.valCheck(this.original_release_date)){
            payload['original_release_date']= this.original_release_date
        }else{
          payload['original_release_date']= null
        }
        if(this.copyright == 'transfer'){
          if(!this.valCheck(this.transfer_name)){
            payload['transfer_company'] = this.transfer_name
          }else{
            this.alert({msg:'양도사를 입력해주세요.'})
            return false
          }
          if(!this.valCheck(this.transfer_date)){
            payload['transfer_date'] = this.transfer_date
          }else{
            this.alert({msg:'양도일을 입력해주세요.'})
            return false
          }
        }
        
        if(this.files1.length > 0){
          payload['coverimage_id'] = this.file1.id
        }
        if(this.files2.length > 0){
          payload['labelimage_id'] = this.file2.id
        }
        if (this.contract.territory == 'global' && this.contract.territory_exception) {
          payload.contract['territory_exception'] = 'korea'
          payload.contract['territory_exception_v2'] = ['korea']
        }else{
          delete payload.contract.territory_exception
          payload.contract['territory_exception_v2'] = []
        }
        
        let artists = []
        for(var a in this.selectArtist){
          artists.push({id :this.selectArtist[a].id});
        }

        payload['artists'] =  artists


        let trackArray = []
        const trackListData =this.trackList
        for(var i in trackListData){
          if(i != 0 && trackListData[i].length == 0){
            this.alert({msg:'Volume2부터는 1곡이상이 있어야합니다.'})
            return false
          }
          
          for(var j in trackListData[i]){
            trackListData[i][j].volume =  Number(i) + 1
            trackListData[i][j].tracknr =  Number(j) + 1
            delete trackListData[i][j].saveArtist
            delete trackListData[i][j].saveFile
            delete trackListData[i][j].saveGenre
          }
          trackArray = trackArray.concat(trackListData[i])
        }
        payload['tracks'] = trackArray
        
        
        console.log(payload['tracks'])
        console.log(this.trackList)
        

        this.loadingShow();
        this.$store.dispatch("POST_ALBUM", payload)
        .then(result =>{
          this.loadingHide();
          this.noti('앨범이 정상적으로 등록 되었습니다.')
          this.$router.push({path: '/album'})
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({
                msg: error.response.data.message,
              })
              break;
          }
        })
      },
      openAudio(index,indextr){
        let file = this.trackList[index][indextr].saveFile
        this.audioList = []
        for(var i in file){
          this.audioList.push(
            {
              ...file[i].response[0],
              name: file[i].display_name,
              artist: '',
              url: file[i].remote_path,
              cover: 'ddd', 
            }
          )
        }
        console.log(this.audioList)
        this.openModal('audio')
        this.$forceUpdate()
      },
      openLyrics(index,indextr){
        this.trackDetail = {...this.trackList[index][indextr]}
        
        this.openModal('lyrics')
      },
      cancel(){
        this.confirm({
          title : '취소 확인',
          msg : `
            정말 나가시겠습니까?
          `,
          action : ()=>{
              this.$router.push({path: '/album'})
          }
        })
      },
      setUserFee(){
        if(this.selectLicensor.length == 0){
          this.alert({msg : '라이센서 매칭을 진행해주세요.'})
          return false
        }
        this.contract.service_fee_kr = this.selectLicensor[0].licensor.default_service_fee_kr
        this.contract.service_fee_other = this.selectLicensor[0].licensor.default_service_fee_other
      },
      updateLang(data){
        this.name_multilang = data
        this.$forceUpdate()
      },
      updateDjLang(data){
        this.name_export = data
        this.$forceUpdate()
      },

      updateTrackLang(data){
        this.trackDetail.name_multilang =data
        this.$forceUpdate()
      },
      updateTrackDjLang(data){
        this.trackDetail.name_export = data
        this.$forceUpdate()
      },
  },
    
}
</script>

<style scoped>

</style>